module.exports = __webpack_public_path__ + "static/img/videostart.6e84207.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/videostart.png
// module id = KqdW
// module chunks = 110